import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class GlobeIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M8 16a8 8 0 1 0-8-8 8.018 8.018 0 0 0 8 8zM7.303 5.44l1.562-1.074a.54.54 0 0 0 .207-.697L8.32 1.9a6.088 6.088 0 0 1 5.797 6.098 6.846 6.846 0 0 1-.056.867.687.687 0 0 0-.207-.095l-2.466-.64a.472.472 0 0 0-.32.056l-2.071.885a.66.66 0 0 1-.922-.49l-.339-1.466a.426.426 0 0 0-.188-.302l-.47-.357c-.302-.227-.227-.697.226-1.016zM2.015 6.701l3.35 2.052 1.13.338a.51.51 0 0 1 .357.32l.545 1.432a.413.413 0 0 1 .02.169v3.067A6.114 6.114 0 0 1 1.882 8a7.121 7.121 0 0 1 .132-1.298z"/></svg>
        )
    }
}

export default withCssClassName(GlobeIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/globe-icon.js